import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateAuthorService } from 'src/app/core/services/create-author.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-author',
  templateUrl: './create-author.component.html',
  styleUrls: ['./create-author.component.css']
})
export class CreateAuthorComponent implements OnInit {

  authors: any[] = [];
  authorForm!: FormGroup;
  uploading: boolean = false;
  previewUrl: string | null = null;

  loading: boolean = false;
  errorMsg: string | null = null;

  //para saber si estamos editando
  editingId: number | null = null;
  descripcionLength: number = 0;

  // buscador
  searchTerm: string = '';
  filteredAuthors: any[] = [];

  constructor(
    private fb: FormBuilder,
    private authorService: CreateAuthorService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.getAuthors();
    this.authorForm.get('descripcion')?.valueChanges.subscribe(val => {
      this.descripcionLength = val ? val.length : 0;
    });
  }

  updateCharCount() {
    const val = this.authorForm.get('descripcion')?.value || '';
    this.descripcionLength = val.length;
  }

  initForm() {
    this.authorForm = this.fb.group({
      nombre: ['', Validators.required],
      cargo: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      facebook: [''],
      twitter: [''],
      instagram: [''],
      descripcion: ['', Validators.required], 
      ruta_foto: ['', Validators.required]   
    });
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    this.uploading = true;

    this.authorService.uploadPhoto(file).subscribe({
      next: (res) => {
        const photoUrl = res.url || res.ruta_foto || res.path;
        this.authorForm.patchValue({ ruta_foto: photoUrl });
        this.previewUrl = photoUrl;
        this.uploading = false;
      },
      error: (err) => {
        console.error('❌ Error al subir foto:', err);
        this.uploading = false;
      }
    });
  }

  // Nuevo método: activar edición
  editAuthor(author: any) {
    Swal.fire({
      icon: 'info',
      title: 'Puedes editar',
      text: `Estás editando a ${author.nombre}`,
      confirmButtonText: 'OK',
      confirmButtonColor: '#7C3AED'
    });

    this.editingId = author.id;
    this.authorForm.patchValue(author);
    this.previewUrl = author.ruta_foto;
  }

  cancelEdit() {
    this.authorForm.reset();
    this.previewUrl = null;
    this.editingId = null;

    Swal.fire({
      icon: 'info',
      title: 'Edición cancelada',
      text: 'Volviste al modo de creación de autor',
      confirmButtonText: 'OK',
      confirmButtonColor: '#7C3AED'
    });
  }


  onSubmit() {
    if (this.authorForm.invalid) {
      this.authorForm.markAllAsTouched();
      return;
    }

    const formValues = this.authorForm.value;

    const payload = {
      id: this.editingId, // Si estamos editando, enviamos el id
      nombre: formValues.nombre,
      cargo: formValues.cargo,
      email: formValues.email,
      facebook: formValues.facebook,
      twitter: formValues.twitter,
      instagram: formValues.instagram,
      descripcion: formValues.descripcion,
      ruta_foto: formValues.ruta_foto
    };

    if (this.editingId) {
      this.authorService.updateAuthor(payload).subscribe({
        next: (res) => {
          console.log('✏️ Autor actualizado:', res);
          this.getAuthors();
          this.authorForm.reset();
          this.previewUrl = null;
          this.editingId = null;

          Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'Autor actualizado correctamente',
            confirmButtonText: 'OK',
            confirmButtonColor: '#7C3AED'
          });
        },
        error: (err) => {
          console.error('❌ Error al actualizar autor:', err);
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'No se pudo actualizar el autor. Intenta de nuevo.'
          });
        }
      });
    } else {
      this.authorService.createAuthor(payload).subscribe({
        next: (res) => {
          console.log('✅ Autor creado:', res);
          this.getAuthors();
          this.authorForm.reset();
          this.previewUrl = null;

          Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'Autor creado exitosamente',
            confirmButtonText: 'OK',
            confirmButtonColor: '#7C3AED'
          });
        },
        error: (err) => {
          console.error('❌ Error al crear autor:', err);
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'No se pudo crear el autor. Intenta de nuevo.'
          });
        }
      });
    }
  }

  previewAuthor(author: any) {
    Swal.fire({
      title: `
        <h2 style="font-size: 1.4rem; font-weight: 700; color: #111827; margin: 0; padding: 0;">
          ${author.nombre}
        </h2>
      `,
      html: `
        <div style="display: flex; flex-direction: column; align-items: center; text-align: center; font-family: 'Inter', sans-serif; margin-top: 6px;">
          
          <img src="${author.ruta_foto}" alt="Foto autor"
            style="width: 150px; height: 150px; border-radius: 50%; object-fit: cover; margin: 6px 0 8px 0; border: 2px solid #DDD6FE; box-shadow: 0 3px 8px rgba(0,0,0,0.1);" />
    
          <span style="display: inline-block; background: linear-gradient(90deg, #8B5CF6, #6366F1); color: white; font-weight: 600; font-size: 0.75rem; padding: 3px 10px; border-radius: 9999px; margin-bottom: 10px;">
            ${author.cargo}
          </span>
    
          <div style="text-align: left; width: 100%; max-width: 460px; margin: auto; font-size: 0.86rem; color: #374151; line-height: 1.45; background: #F9FAFB; padding: 10px 14px; border-radius: 8px; box-shadow: inset 0 1px 2px rgba(0,0,0,0.05);">
            <p><strong>Email:</strong> <span style="color:#6D28D9;">${author.email}</span></p>
            <p><strong>Facebook:</strong> ${author.facebook || '<span style="color:#9CA3AF;">N/A</span>'}</p>
            <p><strong>Twitter:</strong> ${author.twitter || '<span style="color:#9CA3AF;">N/A</span>'}</p>
            <p><strong>Instagram:</strong> ${author.instagram || '<span style="color:#9CA3AF;">N/A</span>'}</p>
            
            <hr style="margin: 8px 0; border: none; border-top: 1px solid #E5E7EB;">
            
            <p style="margin-bottom: 3px;"><strong>Descripción:</strong></p>
            <p style="color:#1F2937; margin: 0;">${author.descripcion}</p>
          </div>
        </div>
      `,
      showCloseButton: true,
      focusConfirm: false,
      confirmButtonText: 'Cerrar',
      confirmButtonColor: '#7C3AED',
      width: '580px',
      background: '#FFFFFF',
      customClass: {
        popup: 'rounded-xl shadow-md no-padding-popup',
        title: 'no-padding-title', // 👈 agregamos clase al título
        htmlContainer: 'no-padding-html'
      }
    });
  }  

  getAuthors() {
    this.loading = true;
    this.errorMsg = null;
  
    this.authorService.listAuthors().subscribe({
      next: (res) => {
        this.authors = res?.data || res;
        this.filteredAuthors = [...this.authors]; // copia inicial
        this.loading = false;
      },
      error: (err) => {
        console.error('❌ Error al listar autores:', err);
        this.errorMsg = 'No se pudieron cargar los autores.';
        this.loading = false;
      }
    });
  }
  
  filterAuthors() {
    const term = this.searchTerm.toLowerCase();
    this.filteredAuthors = this.authors.filter(author =>
      author.nombre?.toLowerCase().includes(term) ||
      author.cargo?.toLowerCase().includes(term) // opcional, también por cargo
    );
  }
}
